export default __webpack_public_path__ + "static/media/portfolio-2.7581ecc6.jpg";